import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { MdOutlineHome, MdOutlineInsights, MdSettings } from 'react-icons/md';
import DemoControls from './DemoControls';
import './Sidebar.css';

const navItems = [
  { to: '/home',     icon: MdOutlineHome,     label: 'Home' },
  { to: '/strategy', icon: MdOutlineInsights, label: 'Strategy' },
];

// Sidebar is permanently collapsed (icons only). Labels appear as styled
// tooltips on hover. Demo controls live behind a gear icon at the bottom,
// opening into a side popover.
function Sidebar() {
  const [demoOpen, setDemoOpen] = useState(false);
  const demoWrapRef = useRef(null);
  useEffect(() => {
    if (!demoOpen) return;
    const onDocClick = (e) => {
      if (demoWrapRef.current && !demoWrapRef.current.contains(e.target)) {
        setDemoOpen(false);
      }
    };
    const onKey = (e) => { if (e.key === 'Escape') setDemoOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [demoOpen]);

  return (
    <nav className="sidebar sidebar--collapsed">
      <div className="sidebar-brand">
        <span className="brand-mark">P</span>
      </div>

      <ul className="sidebar-nav">
        {navItems.map(({ to, icon: Icon, label, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                ['nav-item', isActive ? 'nav-item--active' : ''].join(' ').trim()
              }
              data-tooltip={label}
            >
              <span className="nav-icon">
                <Icon size={22} />
              </span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="sidebar-footer">
        <div className="sidebar-demo-wrap" ref={demoWrapRef}>
          <button
            type="button"
            className={`sidebar-demo-toggle ${demoOpen ? 'sidebar-demo-toggle--active' : ''}`}
            onClick={() => setDemoOpen(o => !o)}
            aria-label="Demo controls"
            data-tooltip="Demo controls"
            aria-expanded={demoOpen}
          >
            <MdSettings size={20} />
          </button>
          {demoOpen && (
            <div className="sidebar-demo-popover" role="dialog" aria-label="Demo controls">
              <DemoControls />
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Sidebar;